import { crearClienteSupabase } from '@eg/compartido'

export const supabase = crearClienteSupabase(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
)
